import { ProgressFiller, ProgressContainer, ProgressLabel } from "./ProgressBar.styles";

interface ProgressBarProps {
    completed: number,
    speed?: number
}

export const ProgressBar = ({ completed, speed = 0.5 }: ProgressBarProps) => <ProgressContainer>
    <ProgressFiller completed={completed} speed={speed}>
        <ProgressLabel>{`${completed}%`}</ProgressLabel>
    </ProgressFiller>
</ProgressContainer>